/**
 * 统计-管理方
 */

import StoreDecorator, {
  Action,
  Mutation,
  Getter,
  AutoLoading,
} from '@acgn/herm/lib/store-decorator';

import {
  getManagerStatistics,
  getAdminChartData,
  getAdminLinkList,
  getProuserStatistics,
  getUserStatistics,
  taskCycleAdminDetail,
  retrialCycleAdminDetail,
  overdueApproveAdminDetail,
  overdueCycleAdminDetail,
  overdueSubAdminDetail,
  targetCycleAdminDetail,
  approveAdminDetail,
  reviseOverdue,
  reviseCellnum,
  reviseLog,
  reviseOverdueLog,
  linkStatistics,
  getUserLinks,
  getProjectBudget,
  setProjectBudget,
  getLinkSetlle,
  setLinkSettle
} from '../../api/statistic';

interface StateType {
}
@StoreDecorator
@AutoLoading
class StoreModule {
  public state() {
    return {};
  }

  // 管理方-数据总览
  // 卡片数据
  @Action()
  public async getManagerStatistics(state: StateType, payload: any) {
    return await getManagerStatistics(payload);
  }
  // 卡片数据(项目-创作方)
  @Action()
  public async getProuserStatistics(state: StateType, payload: any) {
    return await getProuserStatistics(payload);
  }
  // 卡片数据(项目-创作方-管理方)
  @Action()
  public async getUserStatistics(state: StateType, payload: any) {
    return await getUserStatistics(payload);
  }

  // 图表数据
  @Action()
  public async getAdminChartData(state: StateType, payload: any) {
    return await getAdminChartData(payload);
  }

  // 获取创作环节列表
  @Action()
  public async getAdminLinkList(state: StateType, payload: any) {
    return await getAdminLinkList(payload);
  }

  // 任务情况明细
  @Action()
  public async getTaskCycleAdminDetail(state: StateType, payload: any) {
    return await taskCycleAdminDetail(payload);
  }

  // 按环节情况统计【管理方】
  @Action()
  public async getLinkStatistics(state: StateType, payload: any) {
    return await linkStatistics(payload);
  }
  // 按环节情况统计【用户】
  @Action()
  public async getUserLinks(state: StateType, payload: any) {
    return await getUserLinks(payload);
  }

  // 过审情况明细
  @Action()
  public async getRetrialCycleAdminDetail(state: StateType, payload: any) {
    return await retrialCycleAdminDetail(payload);
  }

  // 逾期审批明细
  @Action()
  public async getOverdueApproveAdminDetail(state: StateType, payload: any) {
    return await overdueApproveAdminDetail(payload);
  }

  // 逾期提交明细
  @Action()
  public async getOverdueSubAdminDetail(state: StateType, payload: any) {
    return await overdueSubAdminDetail(payload);
  }

  // 逾期情况明细
  @Action()
  public async getOverdueCycleAdminDetail(state: StateType, payload: any) {
    return await overdueCycleAdminDetail(payload);
  }

  // 目标情况明细
  @Action()
  public async getTargetCycleAdminDetail(state: StateType, payload: any) {
    return await targetCycleAdminDetail(payload);
  }

  // 审批明细
  @Action()
  public async getApproveAdminDetail(state: StateType, payload: any) {
    return await approveAdminDetail(payload);
  }

  // 修改逾期
  @Action()
  public async reviseOverdue(state: StateType, payload: any) {
    return await reviseOverdue(payload);
  }

  // 修改格子
  @Action()
  public async reviseCellnum(state: StateType, payload: any) {
    return await reviseCellnum(payload);
  }

  // 格子修改记录
  @Action()
  public async reviseLog(state: StateType, payload: any) {
    return await reviseLog(payload);
  }

  // 逾期修改记录
  @Action()
  public async reviseOverdueLog(state: StateType, payload: any) {
    return await reviseOverdueLog(payload);
  }

  // 获取项目预算
  @Action()
  public async getProjectBudget(state: StateType, payload: any) {
    return await getProjectBudget(payload);
  }

  // 设置项目预算
  @Action()
  public async setProjectBudget(state: StateType, payload: any) {
    return await setProjectBudget(payload);
  }

  // 设置项目预算
  @Action()
  public async getLinkSetlle(state: StateType, payload: any) {
    return await getLinkSetlle(payload);
  }

  // 设置项目预算
  @Action()
  public async setLinkSettle(state: StateType, payload: any) {
    return await setLinkSettle(payload);
  }

}

export default new StoreModule();
